import * as AnimationModule from "./animations";
import * as RendererModule from "./renderer";
import * as ComponentsModule from "./components";

export function addListeners(){
    if (Shopify.designMode) {
        document.addEventListener("shopify:section:load", async function() {
            AnimationModule.start();
            await RendererModule.renderReactBlocks(ComponentsModule.getComponents());
        });

        document.addEventListener("shopify:section:unload", async function() {
            AnimationModule.start();
            await RendererModule.renderReactBlocks(ComponentsModule.getComponents());
        });

        document.addEventListener("shopify:block:select", async function() {
            AnimationModule.start();
            await RendererModule.renderReactBlocks(ComponentsModule.getComponents());
        });
    }
}
